import axiosInstance from "./axiosInstance";
import {CommentPostProps} from "../types/ComponentProps";

const addComment = async (formData: CommentPostProps, postId: number) => {
  const accessToken = localStorage.getItem("accessTokenGC");
  try {
    const payload: Record<string, any> = {
      message: formData.message,
    };

    if (formData.pointsGiven && formData.pointsGiven > 0) {
      payload.pointsGiven = formData.pointsGiven;
    }

    if (formData.coinsGiven && formData.coinsGiven > 0) {
      payload.coinsGiven = formData.coinsGiven;
    }

    if (formData.recipients && formData.recipients.length > 0) {
      payload.recipients = formData.recipients;
    }

    if (formData.hashTagIds && formData.hashTagIds.length > 0) {
      payload.hashTagIds = formData.hashTagIds;
    }

    const data = await axiosInstance.post(
      `/api/createAPostComment/${postId}`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return data;
  } catch (error) {
    throw new Error("Error creating comment");
  }
};

export default addComment;
